<template>
  <div class="VueCarousel-navigation">
    <button
      type="button"
      aria-label="Previous page"
      :tabindex="canAdvanceBackward ? 0 : -1"
      class="VueCarousel-navigation-button VueCarousel-navigation-prev"
      v-on:click.prevent="triggerPageAdvance('backward')"
      v-bind:class="{'VueCarousel-navigation--disabled': !canAdvanceBackward, 'custom': !simpleButtons}"
      v-bind:style="`padding: ${clickTargetSize}px; margin-right: -${clickTargetSize}px; left: ${
        simpleButtons ? 0 : clickTargetSize * 6
      }px`"
      v-html="prevLabel"
    ></button>
    <button
      type="button"
      aria-label="Next page"
      :tabindex="canAdvanceForward ? 0 : -1"
      class="VueCarousel-navigation-button VueCarousel-navigation-next"
      v-on:click.prevent="triggerPageAdvance('forward')"
      v-bind:class="{'VueCarousel-navigation--disabled': !canAdvanceForward, 'custom': !simpleButtons}"
      v-bind:style="`padding: ${clickTargetSize}px; margin-left: -${clickTargetSize}px; right: ${
        simpleButtons ? 0 : clickTargetSize * 6
      }px`"
      v-html="nextLabel"
    ></button>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'navigation',
    inject: ['carousel'],
    props: {
      /**
       * Amount of padding to apply around the label in pixels
       */
      clickTargetSize: {
        type: Number,
        default: 8
      },
      /**
       * Text content of the navigation next button
       */
      nextLabel: {
        type: String,
        default: '&#9654'
      },
      /**
       * Text content of the navigation prev button
       */
      prevLabel: {
        type: String,
        default: '&#9664'
      },
      /**
       * If false, both navigation buttons will have white background applied
       */
      simpleButtons: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      /**
       * @return {Boolean} Can the slider move forward?
       */
      canAdvanceForward() {
        return this.carousel.canAdvanceForward || false
      },
      /**
       * @return {Boolean} Can the slider move backward?
       */
      canAdvanceBackward() {
        return this.carousel.canAdvanceBackward || false
      }
    },
    methods: {
      /**
       * Trigger page change on +/- 1 depending on the direction
       * @param {"backward"} [direction]
       * @return {void}
       */
      triggerPageAdvance(direction) {
        /**
         * @event paginationclick
         * @type {string}
         */
        this.$emit('navigationclick', direction)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .VueCarousel-navigation-button {
    position: absolute;
    top: 50%;
    box-sizing: border-box;
    color: #000;
    text-decoration: none;
    appearance: none;
    border: none;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
    outline: none;

    &.custom {
      background-color: #ffffff;
      box-shadow: 0px 5px 10px rgba(31, 31, 31, 0.12);
      border-radius: 10px;
    }
  }

  .VueCarousel-navigation-button:focus {
    outline: 1px solid lightblue;
  }

  .VueCarousel-navigation-next {
    right: 0;
    transform: translateY(-50%) translateX(100%);
    font-family: 'system';
  }

  .VueCarousel-navigation-prev {
    left: 0;
    transform: translateY(-50%) translateX(-100%);
    font-family: 'system';
  }

  .VueCarousel-navigation--disabled {
    opacity: 0.5;
    cursor: default;
  }

  /* Define the "system" font family */
  @font-face {
    font-family: system;
    font-style: normal;
    font-weight: 300;
    src: local('.SFNSText-Light'), local('.HelveticaNeueDeskInterface-Light'), local('.LucidaGrandeUI'), local('Ubuntu Light'),
      local('Segoe UI Symbol'), local('Roboto-Light'), local('DroidSans'), local('Tahoma');
  }
</style>
